export const EDIT_REDEMPTION_REQUEST_REFFERAL_LOCAL_STORAGE_KEY = "redemptionRequestReferenceId";
export const EDIT_REDEMPTION_REQUEST_REFFERAL_QUERY_KEY = "redemptionId";